/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OAuthGrants } from './OAuthGrants';
import {
    OAuthGrantsFromJSON,
    OAuthGrantsFromJSONTyped,
    OAuthGrantsToJSON,
    OAuthGrantsToJSONTyped,
} from './OAuthGrants';
import type { OAuthScopes } from './OAuthScopes';
import {
    OAuthScopesFromJSON,
    OAuthScopesFromJSONTyped,
    OAuthScopesToJSON,
    OAuthScopesToJSONTyped,
} from './OAuthScopes';

/**
 * 
 * @export
 * @interface OAuthClient
 */
export interface OAuthClient {
    /**
     * 
     * @type {string}
     * @memberof OAuthClient
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthClient
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthClient
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthClient
     */
    owner: string;
    /**
     * 
     * @type {boolean}
     * @memberof OAuthClient
     */
    isEnabled: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof OAuthClient
     */
    redirectUris: Array<string>;
    /**
     * 
     * @type {Array<OAuthGrants>}
     * @memberof OAuthClient
     */
    grants?: Array<OAuthGrants>;
    /**
     * 
     * @type {Array<OAuthScopes>}
     * @memberof OAuthClient
     */
    scopes?: Array<OAuthScopes>;
    /**
     * 
     * @type {number}
     * @memberof OAuthClient
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof OAuthClient
     */
    updatedAt?: number;
}

/**
 * Check if a given object implements the OAuthClient interface.
 */
export function instanceOfOAuthClient(value: object): value is OAuthClient {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('owner' in value) || value['owner'] === undefined) return false;
    if (!('isEnabled' in value) || value['isEnabled'] === undefined) return false;
    if (!('redirectUris' in value) || value['redirectUris'] === undefined) return false;
    return true;
}

export function OAuthClientFromJSON(json: any): OAuthClient {
    return OAuthClientFromJSONTyped(json, false);
}

export function OAuthClientFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthClient {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'logo': json['logo'] == null ? undefined : json['logo'],
        'owner': json['owner'],
        'isEnabled': json['isEnabled'],
        'redirectUris': json['redirectUris'],
        'grants': json['grants'] == null ? undefined : ((json['grants'] as Array<any>).map(OAuthGrantsFromJSON)),
        'scopes': json['scopes'] == null ? undefined : ((json['scopes'] as Array<any>).map(OAuthScopesFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
    };
}

export function OAuthClientToJSON(json: any): OAuthClient {
    return OAuthClientToJSONTyped(json, false);
}

export function OAuthClientToJSONTyped(value?: OAuthClient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'logo': value['logo'],
        'owner': value['owner'],
        'isEnabled': value['isEnabled'],
        'redirectUris': value['redirectUris'],
        'grants': value['grants'] == null ? undefined : ((value['grants'] as Array<any>).map(OAuthGrantsToJSON)),
        'scopes': value['scopes'] == null ? undefined : ((value['scopes'] as Array<any>).map(OAuthScopesToJSON)),
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

